/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUser200Response
 */
export interface AddUser200Response {
    /**
     * 
     * @type {string}
     * @memberof AddUser200Response
     */
    uid?: string;
}

/**
 * Check if a given object implements the AddUser200Response interface.
 */
export function instanceOfAddUser200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddUser200ResponseFromJSON(json: any): AddUser200Response {
    return AddUser200ResponseFromJSONTyped(json, false);
}

export function AddUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUser200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
    };
}

export function AddUser200ResponseToJSON(value?: AddUser200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
    };
}

